import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const EHSFindingData = () => {

    const sections = [
        { label: "Contractor Involved", value: "ContractorInvolved", items: [] },
        { label: "Status of Compliance", value: "StatusofCompliance", items: [] },
        { label: "Reported By", value: "ReportedBy", items: [] },
        // { label: "PTW Issued", value: "PTWIssued", items: [] },
        { label: "Category", value: "Category", items: [] },
        // { label: "Stop Work Recommended", value: "StopWorkRecommended", items: [] },
        { label: "Action Owner", value: "ActionOwner", items: [] },
        { label: "Verified By", value: "VerifiedBy", items: [] },
        { label: "Severity", value: "Severity", items: [] },
    ];

    return (
        <MasterData pageTitle="EHSFinding" sections={sections} />
    );
};

export default EHSFindingData;